import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {UserCRUDRecord} from "@commons/mapping/UserCRUDRecord";
import {useAppDispatch, useAppSelector} from "@hooks/redux-hooks/hooks";
import {selectAzienda, selectIsBusy, selectPeriodo, selectUser, setupBusy} from "@commons/core.slice";
import PeriodoRif from "@components/PeriodoRif";
import Banner, {bannerStyle} from "@components/Banner";
import {PeriodoForm, useHandlersPeriodoForm} from "@hooks/useHandlersPeriodoForm";
import {IndiceMese, Periodo, Trace} from "@commons/types";
import {useForm} from "react-hook-form";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import {LavoratorePresenzeRecord} from "@commons/mapping/LavoratorePresenzeRecord";
import {defaultOpt, usePresenze, UsePresenzeOptions} from "@commons/hooks/usePresenze";
import {GPReturnType} from "@commons/services/presenze_calcolo/GestionePlusCommonCtrl";
import {DataTablesSchema} from "@commons/mapping/DataTablesSchema";
import Pagination from "@components/dataTable/Pagination";
import {DndProvider} from "react-dnd";
import {HTML5Backend} from "react-dnd-html5-backend";
import {ItemTypes} from "../../../core/DnDItemTypes";
import {PaletteAziende, PaletteGiustificativi, PaletteTurni} from "../comps/Palettes";
import {useOutletContext} from "react-router-dom";
import {OutletContexParams} from "../../Layout";
import {RowLavoratore} from "./comps/Lavoratore";
import {usePagination} from "@components/dataTable/usePagination";
import {useClientSideProcessing} from "@components/dataTable/useClientSideProcessing";
import {TurnoRecord} from "@commons/mapping/TurnoRecord";
import {CausaliGiornata, PresenzeGiornataPlusRecord} from "@commons/mapping/PresenzeGiornataPlusRecord";
import {cloneDeep, isArray} from "lodash";
import {GiustificativoRecord} from "@commons/mapping/GiustificativoRecord";
import styles from "./pianificazione.module.css";
import EditGiu from "./comps/Giustificativo.modal";
import {RiepilogoOrePlus} from "@commons/mapping/RiepilogoOrePlus";
import PlanUL from "./comps/PlanUL.modal";
import {PresenzePianificazioneRecord} from "@commons/mapping/PresenzePianificazioneRecord";
import {useValoriTabellaAzienda} from "@commons/services/presenze_api/tabelleAzienda.queries";
import {mapTabelle} from "@commons/services/presenze_api/tabelleAzienda.api";
import SliderPianificazione from "./comps/SliderPianificazione";
import EditPrevisto, {EditPrevistoFormValues} from "./comps/Previsto.modal";
import {Coppia} from "@commons/mapping/Calc";
import {PageLengthSelector} from "@components/dataTable/TableTitle";
import {useWeekPeriodo} from "@hooks/useWeekPeriodo";
import MultiComboBox from "../../PVA/MultiComboBox";
import {CentroDiCostoRecord} from "@commons/mapping/CentroDiCostoRecord";
import TooltipEx from "@components/Tooltip";
import {TipoOrdinamento, usePostStampaPianificazione} from "@commons/services/presenze_api/stampa.queries";
import {toast} from "react-toastify";
import {customToastWithLink} from "../../../features/export";
import {DateTime} from "luxon";
import Loading from "@components/dataTable/Loading";
import {GiustificativoFilter} from "../GiustificativoFilter";
import {StatoWeekPLUSRecord} from "@commons/mapping/StatoWeekPLUSRecord";
import {CoppiaTimbrature} from "@commons/mapping/CoppiaTimbrature";
import {Utils} from "@commons/mapping/PresenzeGiornataPlusRecord.pianificazione";
import {CircularProgressbar} from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import {useGetDefinizioniGruppiQuery} from "@commons/features/azienda/tabelle/aziendaMapping.api";
import {PresenzeGiustificativo} from "@commons/mapping/PresenzeGiustificativo";
import {GiustificazioneDiMassaTask} from "@commons/services/presenze_calcolo/sub_calcolo/GiustificazioneDiMassaTask";
import {GestionePlusData} from "@commons/services/presenze_calcolo/GestionePlusData";
import {IconPlayerTrackNextFilled, IconPlayerTrackPrevFilled} from "@tabler/icons-react";
import {ModalOnSavePresenzeError, SavePresenzeError} from "../comps/ModalOnSavePresenzeError";
import {LabelPVAFilter} from "../../PVA/PVAFilter";
import {PVAFormData} from "@commons/mapping/PVAFormData";
import ModalPVAFilter from "./comps/ModalPVAFilter";
import {checkPVAFilter, lavoratori2MiniLavoratori, MiniLavoratore} from "./MiniLavoratore";
import {InfoModal} from "@components/ConfirmModal";
//import {setAutoFreeze} from 'immer';
//setAutoFreeze(false);

export interface IdGiornata {
    lavoratore: LavoratorePresenzeRecord,
    day: PresenzeGiornataPlusRecord,
}

export interface GiuXGiornata extends IdGiornata {
    giustificativo?: GiustificativoRecord,
}

interface ULXGiornata extends IdGiornata {
    unitaLocale?: AziendaRecord,
}

interface PianificazioneForm extends PeriodoForm {
    idLavoratore: number;
    codMansione: string | null;
    mansioni: CentroDiCostoRecord[];
}

const initialStateSearch: PVAFormData = PVAFormData.factory();

export const Pianificazione: React.FC = () => {

    //const [windowSize,] = useWindowResize();
    const dispatch = useAppDispatch();
    const weeksContainerRef = useRef<HTMLDivElement | null>(null)
    const isBusy: boolean = useAppSelector(selectIsBusy);
    const user: UserCRUDRecord | null = useAppSelector(selectUser); // User corrente

    const selectedAz = useAppSelector(selectAzienda);
    const azienda: AziendaRecord | undefined = selectedAz ? selectedAz : undefined;// Azienda corrente
    const [showTable, setNextShowTable] = useState<boolean>(true);

    const [showRiepiloghi, setShowRiepiloghi] = useState<boolean>(true);
    const [showCalendario, setShowCalendario] = useState<boolean>(true);
    const [showOre, setShowOre] = useState<boolean>(true);
    const [showTurno, setShowTurno] = useState<boolean>(true);

    const [filterOpen, setFilterOpen] = useState<boolean>(false);
    const hookPvaFilter = useForm<PVAFormData>({defaultValues: PVAFormData.factory()});

    const [isPianificazioneLoading, setPianificazioneLoading] = useState<boolean>(true);
    const [isStampaInCorso, setStampaInCorso] = useState<boolean>(false);
    const [indexLoading, setIndexLoading] = useState<number>(0);

    const [wasError, setWasError] = useState<SavePresenzeError | null>(null);
    const [weekOffset, setWeekOffset] = useState<number>(0);

    const [presenzeGiornata, setPresenzeGiornata] = useState<GiuXGiornata | null>(null);
    const [pianificazioneULGiornata, setPianificazioneULGiornata] = useState<ULXGiornata | null>(null);
    const [previstoGiornata, setPrevistoGiornata] = useState<IdGiornata | null>(null);

    const stampa = usePostStampaPianificazione({idAziendaMaster: azienda?.idAziendaMaster!, idAzienda: azienda?.idAzienda!});
    const [isOpenInfo, setIsOpenInfo] = useState<boolean>(false);
    const [lastError, setLastError] = useState<string | null>(null);

    // Gestione selezione anno/mese
    const [periodo, setNextPeriodo] = useState<Periodo>(useAppSelector(selectPeriodo));

    const {data: dataDefGruppi, isLoading: isLoadingDefGruppi} = useGetDefinizioniGruppiQuery({
        idAziendaMaster: azienda ? azienda.idAziendaCDIC : 0
    });
    const {data: mansioni, isLoading: isLoadingMansioni} = useValoriTabellaAzienda(azienda ? {
        idAziendaTabelle: azienda.idAziendaCDIC,
        idTabella: mapTabelle.MANSIONE.url
    } : null); // Carico tabella raggruppamento

    const initialState: DataTablesSchema<MiniLavoratore> = useMemo<DataTablesSchema<MiniLavoratore>>(() => {
        return {
            data: [],
            recordsFiltered: 0,
            recordsTotal: 0,
        }
    }, []);
    const [elencoLavoratoriPeriodo, setElencoLavoratoriPeriodo] = useState<DataTablesSchema<MiniLavoratore>>(initialState);

    // Hook di caricamento e gestione Presenze
    const opt = useMemo<UsePresenzeOptions>((): UsePresenzeOptions => {
        return {
            ...defaultOpt,
            selFirst: false, // Inibisco caricamento automatico del primo lavoratore utile!
            isPaginaPianificazione: true,
            loadUL: true, // Attivo caricamento unità locali anche se non master!
            onLoadStart: () => {
                setElencoLavoratoriPeriodo({
                    data: [],
                    recordsFiltered: 0,
                    recordsTotal: 0,
                });
            },
            onLoadComplete: (lavoratori: LavoratorePresenzeRecord[], _idLavoratore: number | null) => {
                console.log('Caricamento lavoratori completato!');
                const miniLavoratori: MiniLavoratore[] = lavoratori2MiniLavoratori(lavoratori);
                setElencoLavoratoriPeriodo({
                    data: miniLavoratori,
                    recordsFiltered: miniLavoratori.length,
                    recordsTotal: miniLavoratori.length,
                });
            },
        }
    }, []);

    const {
        ctrl, lavoratori, updLavoratore, isLoading,
        setDayModified, updateDays, rollback, reloadAll, ctrlCycle,
        listaGiustificativi, listaTurni, listaUnitaLocali, cachePresenze, hasDaysToSave,
    } = usePresenze(azienda, periodo, opt);
    const hasLavoratori: boolean = (lavoratori && lavoratori.length > 0) || false;

    // alla conferma della selezione di anno o mese
    const onApply = useCallback((anno: number, mese: IndiceMese) => {
        if (periodo.anno !== anno || periodo.mese !== mese) {
            //setPianificazioneLoading(true);
            setNextPeriodo({anno, mese});
        }
        setNextShowTable(true);
    }, [periodo]);

    // al cambiamento di anno o mese
    const onChange = useCallback((_anno: number, _mese: number) => {
        setNextShowTable(false);
    }, []);
    const onReloadPeriodo = () => {
        reloadAll();
    };

    const defaultValues: PianificazioneForm = {anno: periodo.anno, mese: periodo.mese, idLavoratore: 0, codMansione: null, mansioni: []};
    const form = useForm<PianificazioneForm>({defaultValues});
    const {control, watch,} = form;
    const periodoRifOptions = useHandlersPeriodoForm(form, onChange, onApply, onReloadPeriodo, {autocommit: true});

    const params = useOutletContext<OutletContexParams>();
    const paletteTop = (params ? params.headerHeight || 0 : 0);

    /*if (gestione)
        console.log('gestione OK!');
    if (ctrl)
        console.log('ctrl OK!');*/

    const pvaFilter = hookPvaFilter.watch();

    const defaultPageLength = user?.idUser === 0 ? 10 : 25;
    const pagination = usePagination<PVAFormData>(initialStateSearch, 1, defaultPageLength);

    const mansioniFiltrate = watch('mansioni');
    /*
    useEffect(() => {
        if (pagination.setSearch) { // Da array a stringa con elementi separati dalla virgola
            pagination.setSearch((mansioniFiltrate && mansioniFiltrate.length) ? mansioniFiltrate.toString() : '');
        }
    }, [pagination, mansioniFiltrate]);
    */

    const localData = useClientSideProcessing<MiniLavoratore, keyof MiniLavoratore, PVAFormData>(elencoLavoratoriPeriodo, pagination, undefined, checkPVAFilter);
    const lavoratoriPagina = localData?.data
    const hasLavoratoriPagina: boolean = (lavoratoriPagina && lavoratoriPagina.length > 0) || false;

    function delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    // *******************************************************************************
    // *******************************************************************************
    // *******************************************************************************
    // useEffect per il caricamento delle presenze per i lavoratori indicati in pagina
    // *******************************************************************************
    // https://stackoverflow.com/questions/55187563/determine-which-dependency-array-variable-caused-useeffect-hook-to-fire
    //useWhatChanged([dispatch, isLoading, setPianificazioneLoading, ctrl, updLavoratore, lavoratoriPagina, hasLavoratori], 'dispatch, isLoading, setPianificazioneLoading, ctrl, updLavoratore, lavoratoriPagina, hasLavoratori');
    useEffect(() => {
        const debug = false;
        const debugFilter = (l: MiniLavoratore) => !debug || l.id === 97206 || l.id === 62124;
        const resetBusy = () => {
            setPianificazioneLoading(false);
            setIndexLoading(0);
            dispatch(setupBusy(false));
        }

        const forEachLavoratore = async (ctrl: GPReturnType, lavoratoriPage: MiniLavoratore[]) => {
            console.log('INIZIO caricamento PIANIFICAZIONE!');
            setIndexLoading(0);
            for (const lavoratore of lavoratoriPage.filter(debugFilter)) {
                console.log(lavoratore.cognome);
                try {
                    const lav = await ctrl.setLavoratoreById(lavoratore.id, false, undefined, undefined, false, true);
                    if (lav) { // se lav è null allora significa che è gia stato precedentemente caricato!
                        console.log('Lavoratore caricato: ', lav.id);
                        updLavoratore(lav); // copio nel lavoratore le proprietà relative alle presenze appena caricate in <gestione>
                    }
                } catch (err) {
                    setIsOpenInfo(true);
                    setLastError(lavoratore!.cognome! + ' ' + lavoratore!.nome! + ': ' + err);
                }
                setIndexLoading(index => index + 1);
            }
            console.log('FINE caricamento PIANIFICAZIONE!');
        }

        if (!isLoading) {
            if (ctrl && hasLavoratori && lavoratoriPagina && lavoratoriPagina.length) {
                setPianificazioneLoading(true);
                delay(500).then(() => forEachLavoratore(ctrl, lavoratoriPagina).then(resetBusy));
                //forEachLavoratore(ctrl, lavoratoriPagina).then(resetBusy);
            } else {
                resetBusy();
            }
        }
    }, [dispatch, isLoading, setPianificazioneLoading, ctrl, updLavoratore, lavoratoriPagina, hasLavoratori]);
    //console.log('isPianificazioneLoading', isPianificazioneLoading);
    // Autosave
    useEffect(() => {
        (async () => {
            if (lavoratoriPagina) {
                for (const lavoratorePagina of lavoratoriPagina) {
                    const lavoratore = lavoratori?.find(lav => lav.id === lavoratorePagina.id);
                    const save = (lavoratore && hasDaysToSave(lavoratore)) || false;
                    if (save) {
                        let wasError = false;
                        try {
                            const days = await ctrl?._salva(false,
                                undefined,
                                undefined,
                                undefined,
                                undefined,
                                true,
                                lavoratore!.days);
                            if (days) {
                                // aggiorno
                                updateDays(days, (day2Update, dayModificato, _week, _lavoratore) => {
                                    day2Update.modified = false
                                    day2Update.lastUpdateTrace = Trace.factory(dayModificato?.lastUpdateTrace);
                                    if (dayModificato?.vociPianificazione && dayModificato?.vociPianificazione.length === 0) {
                                        day2Update.vociPianificazione = []; // hotfix complementare di <consolidaVociDiPianificazione()>
                                    }
                                })
                            }
                        } catch (err) {
                            wasError = true;
                            console.log(err);
                            setWasError({idDip: lavoratore!.id, message: err as string});
                        }
                        if (wasError)
                            break;
                    }
                }
            }
        })();
    }, [ctrl, lavoratori, lavoratoriPagina, updateDays, hasDaysToSave]);

    const onClickGiornata = (event: React.MouseEvent<HTMLDivElement, MouseEvent>, day: PresenzeGiornataPlusRecord) => {
        //console.log(day.idDip, day.dtGiornata);
        const lavoratore = lavoratori?.find(lav => lav.id === day.idDip);
        if (lavoratore) {
            if (event.ctrlKey || event.metaKey)
                setPianificazioneULGiornata({lavoratore, day});
            else
                setPresenzeGiornata({lavoratore, day});
        }
    }

    const onDropTurno = (turno: TurnoRecord | null, target: PresenzeGiornataPlusRecord | PresenzeGiornataPlusRecord[]) => {
        if (turno) {
            if (isArray(target)) {
                for (const day of target) {
                    if (RiepilogoOrePlus.getTotaleHPrev(day.totali))
                        updateTurno(turno, day);
                }
            } else {
                updateTurno(turno, target);
            }
        } else { // Se turno nullo sto trascinando la "Pencil"
            //console.log("Pencil turno!");
            //console.log("target", JSON.stringify(target));
            if (!isArray(target)) { // Pencil attiva solo su singola giornata!
                const lavoratore = lavoratori?.find(lav => lav.id === target.idDip);
                if (lavoratore)
                    setPrevistoGiornata({lavoratore, day: target});
            }
        }
    }
    const onResetTurno = (target: PresenzeGiornataPlusRecord | PresenzeGiornataPlusRecord[]) => {
        if (isArray(target)) {
            for (const day of target) {
                onResetOrario(day);
            }
        } else {
            onResetOrario(target);
        }
    }

    const updateTurno = (turno: TurnoRecord, dayModificato: PresenzeGiornataPlusRecord) => {
        //console.log(dayModificato.idDip, dayModificato.dtGiornata, turno.codTurno);
        updateDays([dayModificato], (day2Update, _undef, week, lavoratore) => {
            day2Update.previsteLocked = true;
            day2Update.codTurno = turno.codTurno;
            day2Update.codTurnoPianificazione = turno.codTurno;
            day2Update.idGiorno = 1;
            day2Update.idGiornoPianificazione = 1;
            aggiornaECalcola(day2Update, week, lavoratore!, []);
        });
    }

    const onDropGiustificativo = (giustificativoTrascinato: GiustificativoRecord, target: PresenzeGiornataPlusRecord | PresenzeGiornataPlusRecord[]) => {
        if (isArray(target)) {
            if (giustificativoTrascinato.tipoOreGiu === 'M') {
                for (const day of target) {
                    const lavoratore = lavoratori?.find(lav => lav.id === day.idDip);
                    if (lavoratore) {
                        const gdm = GiustificazioneDiMassaTask.factory({
                            anno: periodo.anno,
                            mese: periodo.mese,
                            selezioneAutomatica: true,
                            livelloPresenzeChiusura: user?.presenze.chiusura
                        });
                        const hasStatus = GiustificativoFilter.filterHasStatus(giustificativoTrascinato, LavoratorePresenzeRecord.getStatus(lavoratore, day.dtGiornata));
                        const isGiuCompliance = hasStatus && GiustificativoRecord.isGMCompliance(giustificativoTrascinato, day);
                        const isDayCompliance = isGiuCompliance && GiustificativoRecord.isDayCompliance(giustificativoTrascinato, day);
                        const isGMCompliance = isDayCompliance && GiustificazioneDiMassaTask.isGMCompliance(gdm, day, lavoratore);
                        if (isGMCompliance) {
                            let skip = false;
                            const quantita = RiepilogoOrePlus.getTotaleHPrev(day.totali) / 60.0;
                            if (quantita) {
                                const giustificativiAggiornati: PresenzeGiustificativo[] = [];
                                let newIndex: number | null = null;
                                day.causaliHH.forEach((giu, index) => {
                                    if (giu) {
                                        if (!giu.codGiu && newIndex === null) {
                                            newIndex = index;
                                        } else if (giu.codGiu === giustificativoTrascinato.codGiu) {
                                            skip = true; // se la giornata ha già un giustificativo come quello trascinato allora salto la giornata!
                                        } else {
                                            giustificativiAggiornati.push(cloneDeep(giu));
                                        }
                                    }
                                });
                                if (!skip) {
                                    const newGiust = PresenzeGiustificativo.factory({
                                        codGiu: giustificativoTrascinato.codGiu!,
                                        tipoGiu: GiustificativoRecord.getTipoGiu(giustificativoTrascinato)
                                    });
                                    newGiust.quantita = RiepilogoOrePlus.getTotaleHPrev(day.totali) / 60.0;
                                    const previsto = Utils.getPrevisto(day);
                                    if (previsto.length === 1) {
                                        newGiust.oraInizio = previsto[0].entrata!;
                                        newGiust.oraFine = previsto[0].uscita!;
                                    }

                                    if (newIndex === 0) {
                                        giustificativiAggiornati.push(newGiust);
                                    } else if (day.causaliHH.length < PresenzeGiustificativo.maxNumGiustificativi) {
                                        giustificativiAggiornati.push(newGiust);
                                    }
                                    consolidaGiustificativi(day, giustificativiAggiornati);
                                }
                            }
                        }
                    }
                }
            }
        } else {
            const lavoratore = lavoratori?.find(lav => lav.id === target.idDip);
            if (lavoratore) {
                const hasStatus = GiustificativoFilter.filterHasStatus(giustificativoTrascinato, LavoratorePresenzeRecord.getStatus(lavoratore, target.dtGiornata));
                const isDayCompliance = hasStatus && GiustificativoRecord.isDayCompliance(giustificativoTrascinato, target);
                if (isDayCompliance) {
                    setPresenzeGiornata({lavoratore, day: target, giustificativo: giustificativoTrascinato});
                }
            }
        }
    }

    const onDropFiliale = (filiale: AziendaRecord, target: PresenzeGiornataPlusRecord | PresenzeGiornataPlusRecord[]) => {
        if (isArray(target)) {
            for (const day of target) {
                updateFiliale(filiale, day);
            }
        } else {
            updateFiliale(filiale, target);
        }
    }

    const updateFiliale = (unitaLocale: AziendaRecord, day: PresenzeGiornataPlusRecord) => {
        //console.log(day.idDip, day.dtGiornata, unitaLocale.descrizione);
        const lavoratore = lavoratori?.find(lav => lav.id === day.idDip);
        if (lavoratore)
            setPianificazioneULGiornata({lavoratore, day, unitaLocale});
    }

    const consolidaVociDiPianificazione = (dayModificato: PresenzeGiornataPlusRecord, vociAggiornate: PresenzePianificazioneRecord[]) => {
        updateDays([dayModificato], (day2Update, _undef, _week, lavoratore) => {
            day2Update.vociPianificazione = [];
            vociAggiornate.forEach((voce) => {
                //if (voce.idAzienda) hotfix! posto comunque con idAzienda null al fine di forzare la cancellazione!
                //{
                voce.codiceFiscale = lavoratore!.codiceFiscale; // Normalizzo codiceFiscale
                voce.dtGiornata = day2Update.dtGiornata!; // Normalizzo data giornata
                day2Update.vociPianificazione.push(voce);
                //}
            });
            setDayModified(day2Update, true);
        });
        closePopup();
    }

    const consolidaGiustificativi = (dayModificato: PresenzeGiornataPlusRecord, giustificativiAggiornati: CausaliGiornata) => {
        closePopup();
        //console.log(JSON.stringify(giustificativiAggiornati));
        // todo: evitare di salvare se non sono state fatte modifiche!!!
        updateDays([dayModificato], (day2Update, _undef, week, lavoratore) => {
            day2Update.causaliHH = [];
            // Normalizzo codGiu ed eseguo defrag su giustificativi
            giustificativiAggiornati.forEach((giustificativo) => {
                if (giustificativo) {
                    if (giustificativo.tipoGiu === 'ORARIO') {
                        const giu = listaGiustificativi.find(v => v.codGiu!.toUpperCase() === giustificativo.codGiu.toUpperCase()) || null;
                        if (giu && !giu.specificaValore) {
                            // Se non è previsto un valore di specifica allora salvo in valore evento l'intervallo orario:
                            // in questo modo garantisco la possibilità di salvare più giustificativi dello stesso tipo su intervalli orari diversi.
                            // <valoreEvento> è in effetti un campo chiave mentre oraInizio e oraFine non lo sono.
                            giustificativo.valoreEvento = giustificativo.oraInizio + ';' + giustificativo.oraFine;
                        }
                    }
                    day2Update.causaliHH.push({...giustificativo, codGiu: giustificativo.codGiu.toUpperCase()});
                }
            });
            day2Update.causaliHH = PresenzeGiornataPlusRecord.defrag(day2Update.causaliHH);

            // *** CALCOLA GIORNATA ***
            calcola(day2Update, giustificativiAggiornati);

            if (week) {
                const updatedWeek = GestionePlusData.updateTotaliWeek(lavoratore!, lavoratore!, cloneDeep(week), cachePresenze!, periodo.mese);
                if (updatedWeek) {
                    const weekIndex2Update = lavoratore!.weeks!.findIndex(oldWeek => oldWeek.dtInizioWeek === updatedWeek.dtInizioWeek);
                    lavoratore!.weeks![weekIndex2Update] = updatedWeek;
                }
            }
        });
    }

    /**
     * Helper per inizializzare il previsto (strisciata e quantità), calcolo della giornata e aggiornamento dei totali settimanali
     * @param day2Update
     * @param week
     * @param lavoratore
     * @param coppie
     */
    const aggiornaECalcola = (day2Update: PresenzeGiornataPlusRecord, week: StatoWeekPLUSRecord | undefined, lavoratore: LavoratorePresenzeRecord, coppie: CoppiaTimbrature[]) => {
        if (day2Update.previsteLocked) {
            const turno = listaTurni.find(turno => turno.codTurno === day2Update.codTurno);
            PresenzeGiornataPlusRecord.ripristinaPrevisto(day2Update, TurnoRecord.getDistribuzione(turno!, day2Update.idGiorno));
            // TODO calcolare correttamente ore diurne e notturne in base alla fascia associata al lavoratore/turno/azienda
            day2Update.totali!.hPrevDiurne = turno!.distribuzione[day2Update.idGiorno - 1].hhPreviste * 60;
            day2Update.totali!.hPrevNotturne = 0;
            //day2Update.totali!.hPrevDiurneTurno = turno!.distribuzione[0].hhPreviste * 60;
        } else {
            day2Update.previste = [];
            day2Update.totali!.hPrevDiurne = 0;
            day2Update.totali!.hPrevNotturne = 0;
            PresenzeGiornataPlusRecord.copy(day2Update, day2Update.previste, coppie);
            coppie.forEach(coppiaEntrataUscita => {
                const coppia = new Coppia(coppiaEntrataUscita);
                // TODO calcolare correttamente ore diurne e notturne in base alla fascia associata al lavoratore/turno/azienda
                day2Update.totali!.hPrevDiurne += coppia.calc.getCount();
                //day2Update.totali!.hPrevNotturne += coppia.calc.getCount();
            });
            //day2Update.totali!.hPrevDiurneTurno = day2Update.totali!.hPrevDiurne;
        }

        // *** CALCOLA GIORNATA ***
        calcola(day2Update, day2Update.causaliHH);

        if (week) {
            const updatedWeek = GestionePlusData.updateTotaliWeek(lavoratore, lavoratore, cloneDeep(week), cachePresenze!, periodo.mese);
            if (updatedWeek) {
                const weekIndex2Update = lavoratore.weeks!.findIndex(oldWeek => oldWeek.dtInizioWeek === updatedWeek.dtInizioWeek);
                lavoratore.weeks![weekIndex2Update] = updatedWeek;
            }
        }
    }

    const consolidaPrevisto = (dayModificato: PresenzeGiornataPlusRecord, payload: EditPrevistoFormValues, dirtyValues: Partial<EditPrevistoFormValues>) => {
        //console.log(payload);
        if (Object.entries(dirtyValues).length > 0)
            updateDays([dayModificato], (day2Update, _undef, week, lavoratore) => {
                day2Update.previsteLocked = payload.previsteLocked;
                day2Update.codTurno = payload.codTurno;
                if (day2Update.codTurno === day2Update.codTurnoSviluppo) {
                    day2Update.idGiorno = day2Update.idGiornoSviluppo;
                    day2Update.codTurnoPianificazione = 0;
                    day2Update.idGiornoPianificazione = 0;
                } else {
                    day2Update.idGiorno = 1;
                    day2Update.codTurnoPianificazione = payload.codTurno;
                    day2Update.idGiornoPianificazione = 1;
                }
                aggiornaECalcola(day2Update, week, lavoratore!, payload.coppie);
            });

        closePopup();
    }

    const onResetOrario = (dayModificato: PresenzeGiornataPlusRecord) => {
        updateDays([dayModificato], (day2Update, _undef, week, lavoratore) => {
            day2Update.previsteLocked = true;
            day2Update.codTurno = day2Update.codTurnoSviluppo;
            day2Update.idGiorno = day2Update.idGiornoSviluppo;
            day2Update.codTurnoPianificazione = 0;
            day2Update.idGiornoPianificazione = 0;
            aggiornaECalcola(day2Update, week, lavoratore!, []);
        });
        closePopup();
    }

    /**
     * Helper per il calcolo della giornata!
     * @param day2Update
     * @param giustificativiAggiornati
     */
    const calcola = (day2Update: PresenzeGiornataPlusRecord, giustificativiAggiornati: CausaliGiornata) => {
        PresenzeGiornataPlusRecord.resetAnomalia(day2Update);
        const success = RiepilogoOrePlus.calcolaConESenzaTimbrature(day2Update.totali!, giustificativiAggiornati, listaGiustificativi);
        if (!success) {
            PresenzeGiornataPlusRecord.setAnomalia(day2Update, 4);
        } else {
            day2Update.anomalia = 0;
        }
        setDayModified(day2Update, true);
    }

    /**
     * "Chiudo tutti" i pop-up, anche se verosimilmente solo uno è effettivamente aperto...
     */
    const closePopup = () => {
        setPresenzeGiornata(null);
        setPianificazioneULGiornata(null);
        setPrevistoGiornata(null);
    }

    const [numWeek] = useWeekPeriodo(periodo);
    useEffect(() => {
        setWeekOffset(0);
    }, [periodo, ctrlCycle]);
    const weekWidth = 578;// => 8px + 80px*7 + 8px + 2px border dx

    const weekPrecedente = () => {
        if (weekOffset)
            setWeekOffset(offset => offset - weekWidth)
    }

    const weekSuccessiva = () => {
        if (weeksContainerRef && weeksContainerRef.current) {
            const clientWidth = weeksContainerRef.current?.clientWidth; // es. 1441
            if (weekOffset < ((weekWidth * numWeek) - clientWidth)) {
                setWeekOffset(offset => offset + weekWidth)
            }
        }
    }

    const onReload = (idDip: number) => {
        if (ctrl) {
            ctrl.setLavoratoreById(idDip, true).then((lav) => {
                if (lav) {
                    updLavoratore(lav); // copio nel lavoratore le proprietà relative alle presenze appena caricate in <gestione>
                }
            });
        }
        setWasError(null);
    }

    const onRollback = (idDip: number) => {
        rollback(idDip);
        setWasError(null);
    }

    const generaPDF = () => {
        setStampaInCorso(true);
        const lavoratore = lavoratori?.find(lav => lav.id === lavoratoriPagina![0].id);
        const first = 0;
        const last = lavoratore!.days!.length - 1;
        const dataIniziale = DateTime.fromISO(lavoratore!.days![first].dtGiornata!).toFormat('yyyy-LL-dd');
        const dataFinale = DateTime.fromISO(lavoratore!.days![last].dtGiornata!).toFormat('yyyy-LL-dd');
        let ordinamento: TipoOrdinamento = 'NOMINATIVO';
        if (dataDefGruppi)
            for (const gruppo of dataDefGruppi) {
                if (gruppo.defOrderPianificazione)
                    ordinamento = gruppo.idTipo as TipoOrdinamento;
            }
        const promise = stampa.mutateAsync({
            idAziendaMaster: azienda?.idAziendaMaster,
            idAzienda: azienda?.idAzienda,
            anno: periodo.anno,
            mese: periodo.mese,
            dataIniziale, // da indicare come aaaa-mm-dd
            dataFinale, // da indicare come aaaa-mm-dd
            ordinamento,
            idAziendaTabelle: azienda?.idAziendaCDIC,
            //filtroTabella: mansioniFiltrate.length ? mapTabelle.MANSIONE?.url : null,
            //valoriFiltroTabella: mansioniFiltrate,
            pvaFilter: PVAFormData.isActive(pvaFilter) ? pvaFilter : undefined,
        });
        promise.then(({data}) => {
            const URI = data && data.URI ? data.URI : '???';
            toast.success(customToastWithLink('Pianificazione', URI));
            setStampaInCorso(false);
        }, () => {
            toast.error("Errore in generazione della stampa!");
            setStampaInCorso(false);
        });
    }

    /*if (ctrl?.getCache().gruppiEventi)
        console.log(ctrl?.getCache().gruppiEventi.GRUPPO_04);*/
    //console.log('anno', watch('anno'));
    //console.log('mese', watch('mese'));

    // https://www.npmjs.com/package/react-circular-progressbar
    const length = lavoratoriPagina ? lavoratoriPagina.length - 1 : undefined;
    const spinner = length ? <div style={{width: 150, height: 150}}>
        <CircularProgressbar minValue={0} maxValue={length} value={indexLoading} background={true}
                             text={`${Math.trunc((indexLoading * 100) / length)}%`}/>
    </div> : undefined;

    //useWhatChanged([pagination, pvaFilter, filterOpen,], 'pagination, pvaFilter, filterOpen');

    return <Loading loading={isBusy || isLoading || isPianificazioneLoading} spinner={spinner}>
        <div className="mb-4">
            <form>
                <PeriodoRif nameAnno="anno" nameComboMese="mese" className="w-2/3"
                            {...periodoRifOptions}
                            disabled={showTable}
                />
            </form>
        </div>

        {!showTable && <Banner style={bannerStyle.warning} text="Seleziona un periodo e/o premi il bottone Applica!"/>}

        <DndProvider backend={HTML5Backend}>
            {/***********************/}
            {/******* HEADER *******/}
            {showTable &&
                <>
                    {/*<div ref={paletteRef} className="sticky z-10 bg-gray-100 select-none" style={{top: `${paletteTop}px`}}>*/}
                    <div className="sticky z-10 bg-gray-100 select-none" style={{top: `${paletteTop}px`}}>
                        {/***********************/}
                        {/******* PALETTE *******/}
                        <>
                            <div className={styles.palettes}>
                                <div className={styles.containerPalette}>
                                    <PaletteAziende name="unitàLocaliSelezionabili"
                                                    elementi={listaUnitaLocali
                                                        .filter(item => item.idAzienda !== item.idAziendaMaster || item.consideraComeUL) // escludo master
                                                        .filter(item => azienda ? item.idAzienda !== azienda.idAzienda : true) // escludo azienda corrente
                                                    }
                                                    type={ItemTypes.AZIENDA}
                                    />
                                </div>
                                <div className={styles.containerPalette}>
                                    <PaletteTurni name="turniSelezionabili"
                                                  elementi={listaTurni}
                                                  type={ItemTypes.TURNO}
                                    />
                                </div>
                                <div className={styles.containerPalette}>
                                    <PaletteGiustificativi name="giustificativiSelezionabili"
                                                           elementi={listaGiustificativi}
                                                           type={ItemTypes.GIUSTIFICATIVO}
                                    />
                                </div>
                            </div>
                        </>
                        {/***********************/}

                        {/***********************/}
                        {/******* TOOLBAR *******/}
                        <div className="py-1 flex flex-row">

                            <PageLengthSelector currentPageLength={pagination.pageLength} setPageLength={pagination.setPageLength} id={'tabellaLavoratori'}
                                                options={[10, 25, 50, 100]}
                                                label1={<span className="text-sm font-medium">Visualizza:</span>}
                                                label2={<span>lavoratori per pagina</span>}
                            />

                            {false && <div className="max-w-96 ml-2 self-center">
                                <MultiComboBox<CentroDiCostoRecord, PianificazioneForm> label="Mansioni:" inlineLabel={true}
                                                                                        control={control} name="mansioni"
                                                                                        data={mansioni || undefined}
                                                                                        isLoading={isLoadingMansioni}
                                                                                        displayValueFn={(elemento: CentroDiCostoRecord) => CentroDiCostoRecord.getDescrizione(elemento)}
                                                                                        factory={(v) => {
                                                                                            return {id: v}
                                                                                        }}
                                                                                        keyValueFn={(elemento: CentroDiCostoRecord) => elemento.id!}
                                                                                        isSameFn={(a, z) => (a && z) ? a.id === z.id : false}
                                />
                            </div>}
                            <div className="mx-12 self-center px-2 text-sm font-medium">
                                <button
                                    className="btn-combo-yellow mx-1 !px-8"
                                    onClick={() => setFilterOpen(f => !f)}><LabelPVAFilter filtroAttivo={PVAFormData.isActive(pvaFilter)}/>
                                </button>
                            </div>
                            {hasLavoratoriPagina && <>
                                <div className="self-center px-2 text-sm font-medium">Dettaglio:</div>
                                <div className="self-center px-2 w-[250px] h-10">
                                    <SliderPianificazione {...{setShowRiepiloghi, setShowCalendario, setShowOre, setShowTurno}}/>
                                </div>
                                <div className="self-center ml-auto">
                                    <button
                                        className="btn-combo-yellow mx-1"
                                        onClick={() => weekPrecedente()}><IconPlayerTrackPrevFilled className="h-4 w-4 text-white" aria-hidden="true"/></button>
                                    <button
                                        className="btn-combo-yellow mx-1"
                                        onClick={() => weekSuccessiva()}><IconPlayerTrackNextFilled className="h-4 w-4 text-white" aria-hidden="true"/></button>
                                </div>
                            </>}
                        </div>
                        {/***********************/}

                        {/**************************/}
                        {/******* CALENDARIO *******/}
                        {!showCalendario && (lavoratoriPagina && lavoratoriPagina[0]) && <div className="border border-t-gray-200 bg-white pt-2">
                            <RowLavoratore lavoratore={lavoratori?.find(lav => lav?.id === lavoratoriPagina[0].id)!} index={0}
                                           showCalendario={true}
                                           showOre={false}
                                           showTurno={false}
                                           showRiepiloghi={false}
                                           turni={listaTurni}
                                           giustificativi={[]}
                                           showLavoratore={false}
                                           offset={weekOffset}
                            />
                        </div>}
                        {/**************************/}
                    </div>
                </>
            }
            {/***********************/}

            {/**********************************/}
            {/******* Tabella LAVORATORI *******/}
            {showTable &&
                hasLavoratoriPagina &&
                <div className="tabella-lavoratori border border-t-gray-200 select-none">
                    {lavoratoriPagina!.map((lavoratore, index) => {
                        return <RowLavoratore key={lavoratore.id}
                                              lavoratore={lavoratori?.find(lav => lav.id === lavoratore.id)!}
                                              index={index}

                                              showRiepiloghi={showRiepiloghi}
                                              showCalendario={showCalendario}
                                              showOre={showOre}
                                              showTurno={showTurno}
                                              mansioni={mansioni || undefined}
                                              turni={listaTurni}
                                              giustificativi={listaGiustificativi}
                                              onDropFiliale={onDropFiliale}
                                              onDropTurno={onDropTurno}
                                              onResetTurno={onResetTurno}
                                              onDropGiustificativo={onDropGiustificativo}
                                              onClickGiornata={onClickGiornata}
                                              offset={weekOffset}
                                              containerRef={index === 0 ? weeksContainerRef : undefined}
                        />
                    })}
                </div>
            }
            {/**********************************/}
        </DndProvider>

        {/*******************************************/}
        {/******* Selettore pagina LAVORATORI *******/}
        {showTable && <>
            {hasLavoratoriPagina &&
                <>
                    <Pagination dataTables={localData} currentPage={pagination.page} setPage={pagination.setPage} currentPageLength={pagination.pageLength}/>
                    <div className="mt-3 flex flex-row justify-end">
                        <TooltipEx tooltip={`Stampa la pianificazione del periodo indicato`}>
                            <button
                                type="button"
                                className="bg-blue-600 btnPrimary"
                                onClick={generaPDF}
                                disabled={!hasLavoratoriPagina || isStampaInCorso}
                            >
                                Stampa
                            </button>
                        </TooltipEx>
                    </div>
                </>
            }
            {(!lavoratoriPagina || lavoratoriPagina.length === 0) &&
                <Banner className="p-6" style={bannerStyle.warning} text="Nessun dato presente!"/>
            }
        </>
        }

        {/**********************/}
        {/******* MODALI *******/}
        <>
            {presenzeGiornata && <EditGiu {...presenzeGiornata}
                                          turni={listaTurni}
                                          giustificativi={listaGiustificativi}
                                          gruppiEventi={cachePresenze ? cachePresenze.gruppiEventi : {}}
                                          onSave={consolidaGiustificativi}
                                          onCancelEdit={closePopup}/>}
            {previstoGiornata && <EditPrevisto {...previstoGiornata}
                                               turni={listaTurni}
                                               giustificativi={listaGiustificativi}
                                               onSave={consolidaPrevisto}
                                               onCancelEdit={closePopup}
                                               onResetOrario={onResetOrario}
            />}
            {pianificazioneULGiornata && <PlanUL {...pianificazioneULGiornata}
                                                 turni={listaTurni}
                                                 giustificativi={listaGiustificativi}
                                                 elencoUnitaLocali={listaUnitaLocali}
                                                 onSave={consolidaVociDiPianificazione}
                                                 onCancelEdit={closePopup}/>}
            <ModalOnSavePresenzeError wasError={wasError} onRollback={onRollback} onReload={onReload}></ModalOnSavePresenzeError>
            <InfoModal open={isOpenInfo}
                       onCancel={() => setIsOpenInfo(false)}
                       children={lastError}
            />
            <ModalPVAFilter {...{azienda: azienda!, hookPvaFilter, filterOpen, setFilterOpen, pagination}}/>
        </>
        {/**********************/}
    </Loading>;
}